import { getConfigValue } from '@indigo-ag/ui-core';

const salesforceUtils = {
  getDetailURL(id: string, isAccount: boolean = false) {
    const baseUrl = getConfigValue('IA_FINANCING_ADMIN_UI_SALESFORCE_URL');
    return `${baseUrl}/lightning/r/${isAccount ? 'Account' : 'Opportunity'}/${id}/view`;
  },
  getAllOpportunities(id: string) {
    const baseUrl = getConfigValue('IA_FINANCING_ADMIN_UI_SALESFORCE_URL');
    return `${baseUrl}/lightning/r/${id}/related/Opportunities/view`;
  },
  getGenericURL(id: string) {
    const baseUrl = getConfigValue('IA_FINANCING_ADMIN_UI_SALESFORCE_URL');
    return `${baseUrl}/${id}`;
  }
};

export { salesforceUtils };
